import React from "react";
import { withStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";

export default withStyles((theme) => ({
  root: {
    borderRadius: 50,
    " &.Mui-disabled": {
      opacity: 1,
    },
  },
  contained: {
    "& .MuiButton-label": {
      fontWeight: 300,
      fontSize: 24,
      // используется явное указание точек, так как с буквенным не срабатывает
      [theme.breakpoints.between(1024, 1320)]: {
        fontSize: 20,
      },
    },
    "&.Mui-disabled": {
      backgroundColor: "#C8C8C8",
    },
  },
  //eslint-disable-next-line react/display-name
}))(React.forwardRef((props, ref) => <Button {...props} ref={ref} color="primary" variant="contained" />));
